export enum FilterTypes {
    contains = 'CONTAINS',
    greaterThan = 'GREATER_THAN',
    lessThan = 'LESS_THAN',
    bool = 'BOOL'
}
